import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import { Router } from '@angular/router';
import axios from 'src/app/Service/axios';
import Map from 'ol/Map';
import View from 'ol/View';
import OSM from 'ol/source/OSM';
import * as olProj from 'ol/proj';
import TileLayer from 'ol/layer/Tile';
import { BingMaps, XYZ } from 'ol/source';
import { Draw } from 'ol/interaction';
import { Fill, Stroke, Style } from 'ol/style';
import { Polygon } from 'ol/geom';
import Feature from 'ol/Feature';
import VectorSource from 'ol/source/Vector';
import VectorLayer from 'ol/layer/Vector';
import { MapService } from 'src/app/Service/map.service';

declare let $: any;

@Component({
  selector: 'app-tanker-areas',
  templateUrl: './tanker-areas.component.html',
  styleUrls: ['./tanker-areas.component.css']
})

export class TankerAreasComponent implements OnInit {
  lst_Areas:any = [];
  lst_Search = [];
  selectedItem: any;
  editMode: boolean = false;
  ismapCreate: boolean = false;
  map: any;
  source: any;
  vector: any;
  vectorLayer: any;
  draw: any;
  polygonEvent: any;
  layers: any = [];

  private bOfflineMap: boolean = (<any>window).bOfflineMap;
  private strMapUrl: string = (<any>window).strMapUrl;

  mdl_Search: FormGroup = this._formBuilder.group({

    strSession: new FormControl(this._gurd.decrypt(localStorage.getItem('Session')!)),

    iSystemUser: new FormControl(this._gurd.decrypt(localStorage.getItem('ID')!)),

  });

  areaForm: FormGroup = this._formBuilder.group({

    strSession: new FormControl(this._gurd.decrypt(localStorage.getItem('Session')!)),

    iSystemUser: new FormControl(this._gurd.decrypt(localStorage.getItem('ID')!)),

    iMobileDomain: new FormControl(''),

    strComment: new FormControl('', Validators.required),

    lstPoints: new FormControl([])

  });

  constructor(
    private _tooltip: NotificationService,
    private _formBuilder: FormBuilder,
    private _gurd: GurdServiceService,
    public _other: OtherService,
    private _router: Router,
    private mapService: MapService,
  ) {

  }

  ngOnInit(): void {
    this.getAreas();
  }

  getAreas = async () => {

    let model = this.mdl_Search.value;

    this._other.Showspinner();

    let res = JSON.parse((await axios.post(`MobileDomain_List4Tanker`, this._other.stringNumberToNumber(model))).data.toString());

    this._other.nonespinner();

    if (res.ISSessionExpired == true) {

      this._tooltip.showError('لطفا وارد سیستم شوید');

      this._other.removeLocalStorage();

      this._router.navigate(['login'], { queryParams: { error: 'x12z110' } });

      return;

    }

    if (res.iResult == 0) {

      return this._tooltip.showError(res.strError);

    }

    this.lst_Areas = res;
    this.lst_Search = res;

  }

  filterResult(strValue: string) {

    if (strValue.length > 1) {

      this.lst_Areas = this.lst_Search.filter((el: any) => {

        return (el.strComment ?? '').includes(strValue);

      })

    }

    else if (strValue == '') this.lst_Areas = this.lst_Search

  }

  openAddOrUpdateAreaModal(item?: any) {

    // console.log(item)

    if (item) {

      this.editMode = true;

      this.selectedItem = item;

      this.areaForm.patchValue({

        iMobileDomain: item.iMobileDomain,

        strComment: item.strComment,

        lstPoints: item.lstPoints ?? []

      });

      $("#addOrUpdateArea_Modal").modal("show");

      this.initMap();

      setTimeout(() => {

        this.clearPolygon();

        if (item.lstPoints && item.lstPoints.length > 0) {

          this.showPolygon(item.lstPoints);

          this.fitToPoints(item.lstPoints);

        }

      }, 800);

    }

    else {

      this.editMode = false;

      this.selectedItem = undefined;

      this.areaForm.patchValue({

        iMobileDomain: '',

        strComment: '',

        lstPoints: []

      });

      this._other.markAllAsUnTouched(this.areaForm);

      $("#addOrUpdateArea_Modal").modal("show");

      this.initMap();

      setTimeout(() => {

        this.clearPolygon();

        this.map.setView(new View({
          center: olProj.fromLonLat([51.3833554, 35.6770113]),
          zoom: 13,
        }))

      }, 800);

    }

  }

  initMap() {

    if (this.ismapCreate) {

      setTimeout(() => this.map.updateSize(), 200);

      return;

    }

    setTimeout(() => {

      this.source = new VectorSource({ wrapX: false });

      this.vector = new VectorLayer({
        source: this.source,
      });

      if (this.bOfflineMap) {

        this.layers.push(

          new TileLayer({

            source: new XYZ({

              url: this.strMapUrl,

              attributions: 'Map data © RayanAndishehNasr'

            }),

          })

        );

      }

      else {

        const styles = [
          'AerialWithLabelsOnDemand',
        ];

        let i, ii;

        for (i = 0, ii = styles.length; i < ii; ++i) {

          this.layers.push(
            new TileLayer({
              visible: false,
              preload: Infinity,
              source: new BingMaps({
                key: 'Ap0AObt84NcDaUThCeWOj52ZqUHv6k4TJhjLibR-DghC-semgoj-0uPbIi8r0E4j',
                imagerySet: styles[i],
              }),
            })
          );

        }

        this.layers.push(new TileLayer({ source: new OSM({}) }), this.vector);

      }

      this.map = new Map({

        layers: this.layers,

        target: 'areasMap',

        view: new View({
          center: olProj.fromLonLat([51.3833554, 35.6770113]),
          zoom: 13,
        }),

      });

      this.ismapCreate = true;

      this.vector.getSource().on('addfeature', (e: any) => {

        this.polygonEvent = e.feature;

        // حذف feature رسم‌شده توسط تعامل Draw (چون خودمان نمایش را کنترل می‌کنیم)
        this.source.removeFeature(e.feature);

        this.savePolygonPoints();

        // نمایش مجدد محدوده ترسیم‌شده برای کاربر
        this.showPolygon(this.areaForm.controls['lstPoints'].value);

        // غیرفعال کردن حالت رسم برای جلوگیری از ترسیم مجدد ناخواسته
        if (this.draw) this.map.removeInteraction(this.draw);

      });

    }, 300);

  }

  addInteraction() {

    this.clearPolygon();

    const value = 'Polygon';

    this.draw = new Draw({
      source: this.source,
      type: value,
    });

    this.map.addInteraction(this.draw);

  }

  clearPolygon() {

    if (this.source) this.source.clear();

    if (this.vectorLayer) {
      this.map.removeLayer(this.vectorLayer);
      this.vectorLayer = undefined;
    }

    this.areaForm.controls['lstPoints'].setValue([]);

    if (this.draw) this.map.removeInteraction(this.draw);

  }

  savePolygonPoints() {

    var point = [] as any;

    this.draw.sketchLineCoords_.forEach((item: any) => {

      var data = this.mapService.transformCoordinates(item);

      point.push({ fLat: data[1], fLon: data[0] });

    });

    this.areaForm.controls['lstPoints'].setValue(point);

    this._tooltip.showSuccess("محدوده با موفقیت ترسیم شد.");

  }

  showPolygon(point: any[]) {

    if (typeof (point) != 'object') return;

    if (this.vectorLayer) {
      this.map.removeLayer(this.vectorLayer);
      this.vectorLayer = undefined;
    }

    if (point.length != 0) {

      var ring = [];

      for (let index = 0; index < point.length; index++) {

        ring.push([point[index].fLon, point[index].fLat]);

      }

      var polygon = new Polygon([ring]);

      polygon.transform('EPSG:4326', 'EPSG:3857');

      var feature = new Feature(polygon);

      var vectorSource = new VectorSource();

      vectorSource.addFeature(feature);

      var vectorLayer = new VectorLayer({

        source: vectorSource,

        style: new Style({

          stroke: new Stroke({

            color: 'red',

            width: 4,

            lineDash: [10, 20, 10, 20]

          }),

          fill: new Fill({

            color: 'rgba(0, 0, 255, 0)'

          })

        }),

      } as any);

      this.vectorLayer = vectorLayer;

      this.map.addLayer(vectorLayer);

    }

  }

  fitToPoints(obj: any[]) {

    let maxLatitude = -Infinity;
    let maxLongitude = -Infinity;
    let minLatitude = Infinity;
    let minLongitude = Infinity;

    for (const item of obj) {
      if (item.fLat > maxLatitude) maxLatitude = item.fLat;
      if (item.fLon > maxLongitude) maxLongitude = item.fLon;
      if (item.fLat < minLatitude) minLatitude = item.fLat;
      if (item.fLon < minLongitude) minLongitude = item.fLon;
    }

    var transformedStart = this.mapService.transformCoordinates2([maxLongitude, maxLatitude]);
    var transformedEnd = this.mapService.transformCoordinates2([minLongitude, minLatitude]);

    var source = [
      Math.min(transformedStart[0], transformedEnd[0]) - 300,
      Math.min(transformedStart[1], transformedEnd[1]) - 300,
      Math.max(transformedStart[0], transformedEnd[0]) + 300,
      Math.max(transformedStart[1], transformedEnd[1]) + 300,
    ];

    this.map.getView().fit(source);

  }

  submitArea = async () => {

    if (this.areaForm.invalid) {
      this._other.markAllAsTouched(this.areaForm);
      this._tooltip.showError('لطفا عنوان را وارد کنید');
      return;
    }

    if (this.editMode) {

      $.confirm({

        title: `آیا از ویرایش اطلاعات اطمینان دارید ؟`,

        content: '',

        type: 'blue',

        buttons: {

          ok: {

            text: "ویرایش",

            btnClass: 'btn-primary',

            keys: ['enter'],

            action: async () => {

              let model = this.areaForm.value;

              this._other.Showspinner();

              let res = JSON.parse((await axios.post(`MobileDomain_Edit4Tanker`, this._other.stringNumberToNumber(model))).data.toString());

              this._other.nonespinner();

              if (res.ISSessionExpired == true) {

                this._tooltip.showError('لطفا وارد سیستم شوید');

                this._other.removeLocalStorage();

                this._router.navigate(['login'], { queryParams: { error: 'x12z11dx0' } });

                return;

              }

              if (res.iResult == 0) {

                return this._tooltip.showError(res.strError);

              }

              const index = this.lst_Areas.findIndex((el: any) => el.iMobileDomain == model.iMobileDomain);

              if (index != -1) this.lst_Areas[index] = res[0] ?? model;

              this._tooltip.showSuccess('با موفقیت ویرایش شد')

              $("#addOrUpdateArea_Modal").modal('hide');

            }

          },

          cancel: {
            text: "لغو",
          }

        }

      });

    }

    else {

      let model = this.areaForm.value;

      this._other.Showspinner();

      let res = JSON.parse((await axios.post(`MobileDomain_Save4Tanker`, this._other.stringNumberToNumber(model))).data.toString());

      this._other.nonespinner();

      if (res.ISSessionExpired == true) {

        this._tooltip.showError('لطفا وارد سیستم شوید');

        this._other.removeLocalStorage();

        this._router.navigate(['login'], { queryParams: { error: 'x12z11d0' } });

        return;

      }

      if (res.iResult == 0) {

        return this._tooltip.showError(res.strError);

      }

      this.lst_Areas.push(res[0] ?? model);

      this._tooltip.showSuccess('با موفقیت ثبت شد')

      $("#addOrUpdateArea_Modal").modal('hide');

    }

  }

  removeArea(item: any) {

    $.confirm({

      title: `آیا از حذف امور اطمینان دارید ؟`,

      content: '',

      type: 'red',

      buttons: {

        ok: {

          text: "حذف",

          btnClass: 'btn-danger',

          keys: ['enter'],

          action: async () => {

            this._other.Showspinner();

            let model = this._other.stringNumberToNumber({
              ...this.mdl_Search.value,
              iMobileDomain: item.iMobileDomain
            });

            let res = JSON.parse((await axios.post(`MobileDomain_Delete`, model)).data.toString());

            this._other.nonespinner();

            if (res.ISSessionExpired == true) {

              this._tooltip.showError('لطفا وارد سیستم شوید');

              this._other.removeLocalStorage();

              this._router.navigate(['login'], { queryParams: { error: 'x12z110' } });

              return;

            }

            if (res.iResult == 0 && res.strError != '') return this._tooltip.showError(res.strError);

            const index = this.lst_Areas.findIndex((el: any) => el.iMobileDomain == item.iMobileDomain);

            if (index != -1) this.lst_Areas.splice(index, 1);

            this._tooltip.showSuccess('با موفقیت حذف شد');

          }

        },

        cancel: {
          text: "لغو",
        }

      }

    });

  }

}
